<template>
  <div class="flex-1 flex flex-col justify-between">
    <Form class="space-y-6" @submit="editMetric">
      <div class="max-h-full h-full mt-4">
        <div class="flex relative items-center space-x-4">
          <div class="flex-1 min-w-0">
            <div class="w-full gap-2 flex flex-col">
              <div class="w-full flex flex-row items-center gap-2">
                <SelectInput
                  v-if="metric_clone.data_type == 'Number'"
                  :items="metrics_number_options"
                  label-attr="label"
                  value-attr="value"
                  :allow-null="false"
                  :value="metric_clone.input_type"
                  name="metric_type"
                  :placeholder="$t('Input type')"
                  :is-box-background="true"
                  :show-label="true"
                  :label="$t('Input Type')"
                  classes="w-full"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                  @update:currentItem="handleSelect($event, 'metricType')" />
                <SelectInput
                  v-if="metric_clone.data_type == 'String'"
                  :items="metrics_text_options"
                  label-attr="label"
                  value-attr="value"
                  :allow-null="false"
                  :value="metric_clone.input_type"
                  name="metric_type"
                  :placeholder="$t('Input type')"
                  :is-box-background="true"
                  :show-label="true"
                  :label="$t('Input Type')"
                  classes="w-full"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                  @update:currentItem="handleSelect($event, 'metricType')" />
                <SelectInput
                  v-if="metric_clone.input_type == 'Currency'"
                  :items="$consts.currencies"
                  label-attr="label"
                  value-attr="value"
                  :allow-null="false"
                  :value="metric_clone.currency"
                  name="currency"
                  :placeholder="$t('Currency type')"
                  :is-box-background="true"
                  :show-label="true"
                  label="Currency"
                  classes="w-full"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                  @update:currentItem="handleSelect($event, 'currency')" />
                <SelectInput
                  v-if="metric_clone.input_type == 'Decimal'"
                  :items="[
                    { label: 1, value: 1 },
                    { label: 2, value: 2 },
                    { label: 3, value: 3 },
                    { label: 4, value: 4 }
                  ]"
                  label-attr="label"
                  value-attr="value"
                  :allow-null="false"
                  :value="metric_clone.decimal_places"
                  name="decimal_places"
                  :placeholder="$t('Decimal Places')"
                  :is-box-background="true"
                  :show-label="true"
                  :label="$t('Decimal Places')"
                  classes="w-full"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                  @update:currentItem="handleSelect($event, 'decimalPlaces')" />
                <div v-if="metric_clone.input_type == 'Number' || metric_clone.input_type == 'Currency'" class="flex justify-between">
                  <div class="mt-2 text-common-grey">
                    {{ $t("Truncate") }}:
                  </div>
                  <input
                    :checked="metric_clone.truncate"
                    type="checkbox"
                    class="ml-2 mt-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration"
                    @input="(e) => handleSelect(e, 'truncate')">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-2 w-full flex-row justify-between">
        <button type="button" class="cancel-btn w-1/2 m-0" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
        <button type="submit" class="primary-btn w-1/2">{{ $t("Update") }}</button>
      </div>
    </Form>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"

import { Form } from "vee-validate"
import DataService from "@/services/data.service"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    Form,
    SelectInput
  },
  props: {
    metric: {
      type: Object,
      required: true
    }
  },

  emits: ["cancel", "submitted", "done"],

  data() {
    return {
      metrics_number_options: [
        { label: this.$t("Number"), value: "Number" },
        { label: this.$t("Decimal"), value: "Decimal" },
        { label: this.$t("Percent"), value: "Percent" },
        { label: this.$t("Currency"), value: "Currency" },
        { label: this.$t("StarRating"), value: "StarRating" },
        { label: this.$t("BarRating"), value: "BarRating" }
      ],
      metrics_text_options: [
        { label: this.$t("Text"), value: "Text" },
        { label: this.$t("Textarea"), value: "Textarea" },
        { label: this.$t("URL"), value: "URL" }
      ],

      metric_clone: null
    }
  },
  created() {
    this.metric_clone = this.metric
    this.metric_clone.currency = this.metric_clone.input_options
      ? this.metric_clone.input_options.currency
        ? this.metric_clone.input_options.currency
        : this.$t("USD")
      : this.$t("USD")
    this.metric_clone.truncate = this.metric_clone.input_options
      ? this.metric_clone.input_options.truncate === false
        ? false
        : this.metric_clone.input_options.truncate === true
          ? true
          : true
      : true
    this.metric_clone.decimal_places = this.metric_clone.input_options
      ? this.metric_clone.input_options.decimal_places
        ? this.metric_clone.input_options.decimal_places
        : 1
      : 1
  },
  methods: {
    handleSelect(e, type) {
      if (type === "metricType") {
        this.metric_clone.input_type = e
      } else if (type === "currency") {
        this.metric_clone.currency = e
      } else if (type === "truncate") {
        this.metric_clone.truncate = e.target.checked
      }
    },

    editMetric() {
      this.metric_clone.input_options = {}
      this.metric_clone.input_options.currency = this.metric_clone.currency
      this.metric_clone.input_options.truncate = this.metric_clone.truncate
      this.metric_clone.input_options.decimal_places = this.metric_clone.decimal_places

      DataService.updateOrganizationMetric(this.metric_clone).then(() => {
        this.$store.dispatch("data/getMetrics")
        this.$emit("done")
        this.$emitter.emit(ALL_EMITTERS.METRICS_CHANGED)
      })
    }
  }
}
</script>
